import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { FaClockRotateLeft, FaGear } from 'react-icons/fa6'
import {
    Flex,
    Text,
    Spacer,
    Switch,
    Tooltip,
    IconButton,
    Menu,
    MenuButton,
    MenuList,
    Portal,
} from '@chakra-ui/react'

interface Props {
    useLegacySidebar: boolean
    setUseLegacySidebar: (value: boolean) => void
    /** Controlled by the sidebar so it can hold itself open while the portaled menu is up. */
    menuIsOpen: boolean
    onMenuOpen: () => void
    onMenuClose: () => void
}

/**
 * Gear menu at the top right of the sidebar. Houses sidebar-level settings
 * like the legacy sidebar toggle.
 */
const SidebarSettingsMenu: React.FC<Props> = ({
    useLegacySidebar,
    setUseLegacySidebar,
    menuIsOpen,
    onMenuOpen,
    onMenuClose,
}) => {
    return (
        <Menu
            isOpen={menuIsOpen}
            onOpen={onMenuOpen}
            onClose={onMenuClose}
            placement="bottom-end"
            closeOnSelect={false}
        >
            <Tooltip label="Sidebar settings" hasArrow>
                <MenuButton
                    as={IconButton}
                    aria-label="Sidebar settings"
                    icon={<Icon as={FaGear} fontSize="md" />}
                    variant="ghost"
                    rounded="full"
                    size="sm"
                    color="gray.400"
                    bg="transparent"
                    transition="all 0.2s"
                    _hover={{ bg: 'gray.800' }}
                    _active={{ bg: 'gray.800' }}
                />
            </Tooltip>
            {/* Portaled: the sidebar clips overflow, which would cut the menu
            off at the sidebar edge (and shift it during expand). */}
            <Portal>
                <MenuList zIndex={1600} minW="220px" p={2}>
                    <Flex align="center" gap={2} px={2} py={1}>
                        <Icon
                            as={FaClockRotateLeft}
                            boxSize={4}
                            color="gray.500"
                        />
                        <Text fontSize="13px" color="gray.700" noOfLines={1}>
                            Legacy sidebar
                        </Text>
                        <Spacer />
                        <Switch
                            size="sm"
                            colorScheme="brand"
                            isChecked={useLegacySidebar}
                            onChange={e => setUseLegacySidebar(e.target.checked)}
                            aria-label="Use legacy sidebar"
                        />
                    </Flex>
                </MenuList>
            </Portal>
        </Menu>
    )
}

export default SidebarSettingsMenu
